import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import PieChart from "../charts/generic/PieChart"

function LengthOfService({ exportEndpoint, appliedFilters, data, sampleSize }) {
  const titleKey = "Widgets.LengthOfService.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.LengthOfServicePie.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      sampleSize={sampleSize}
    >
      <PieChart data={data} singularTooltipDescriptorKey="Common.Person" pluralTooltipDescriptorKey="Common.People" titleKey={titleKey}/>
    </Widget>
  )
}

LengthOfService.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      key: PropTypes.string
    })
  ).isRequired,
  exportEndpoint: PropTypes.string.isRequired
}

export default LengthOfService



// WEBPACK FOOTER //
// ./src/components/widgets/LengthOfService.jsx